import { PartTypeType } from "../types";
import { isBarOrProfile } from "./isBarOrProfile";
import { isSheetPartType } from "./isSheetPartType";

export const shouldAnalysePartAfterTypeUpdate = (newPartType: PartTypeType) =>
  isBarOrProfile(newPartType) || isSheetPartType(newPartType);
